export const CDN_URI = 'https://d29j2csl3b3dix.cloudfront.net/' //select from _images at site: s3.console.aws.amazon.com/s3/buckets/76-fireworks
